import t from"styled-components";const e=t.div`
	position: absolute;
	bottom: 0;
	right: 20px;
	width: 245px;
	padding: 20px 0;
`,i=t.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	cursor: pointer;
	width: 48px;
	height: 48px;
	float: right;
	background: ${({theme:t})=>t.bg.inverse};
`,o=t.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	position: absolute;
	width: 280px;
	bottom: 110px;
	right: 0;
	padding: 20px;
	z-index: 999;
	box-shadow: 0 4px 12px 0 rgba(0, 41, 111, 0.25);
	background: ${({theme:t})=>t.bg.general};
	border: 1px solid ${({theme:t})=>t.border.black10};
	border-radius: 20px;
`,p=t.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 20px 0;
	border-top: 1px solid ${({theme:t})=>t.border.black15};
	border-bottom: 1px solid ${({theme:t})=>t.border.black15};

	a {
		all: unset;
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: space-between;
		font-size: 12px;
		font-weight: 500;

		div {
			display: flex;
			align-items: center;
			gap: 16px;
		}
	}
`,r=t.div`
	font-family: "PP Formula";
	font-weight: 500;
	font-size: 12px;
	margin-bottom: 10px;
	color: ${({theme:t})=>t.text.title};
`,n=t.div`
	font-size: 12px;
	font-weight: 500;
	color: ${({theme:t})=>t.text.text};
`,d=t.div`
	position: relative;
	background: #d0eaf6;
	border-radius: 8px;
	width: 100%;
	height: 160px;
	margin-top: 10px;

	img {
		position: absolute;
		bottom: 60px;
		left: 25px;
		width: 230px;
		height: 114px;
		object-fit: cover;
	}
`,x=t.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: absolute;
	bottom: 15px;
	left: 15px;
	right: 15px;
`,l=t.div`
	color: ${({theme:t})=>t.text.title};
	font-size: 14px;
	font-weight: 800;
`,a=t.div`
	color: ${({theme:t})=>t.text.text};
	font-size: 10px;
	font-weight: 500;
`;export{p as Content,n as Description,i as HelpButton,e as HelpCenterContainer,o as HelpPopup,r as Title,d as VideoContainer,a as VideoDescription,x as VideoLink,l as VideoTitle};
